import { useNavigate } from "react-router";
import { Button } from "@/ui/Button";
import { Body, Label } from "@/ui/Text";

/**
 * What a locked account sees under today's headline: the shape of the reading
 * it is missing, and the one way to get it.
 */
export function LockedPreview() {
  const navigate = useNavigate();
  return (
    <section className="mt-6 border-[1.5px] border-ink p-5" aria-label="Your full reading">
      <Label className="text-ink">Your full reading</Label>
      <Body className="mt-2">
        Career, money, love and health, each with what to do and what to avoid, plus your best days this week and this
        month.
      </Body>
      <div className="mt-5">
        <Button label="Subscribe" onClick={() => navigate("/subscribe")} />
      </div>
    </section>
  );
}
